import { Box } from '@chakra-ui/react'
import { css } from '@emotion/react'

import { LINE_HEIGHTS } from '@/constants/constants'

import type { SerializedRichText } from '@/client/services/richText/types'

import RichText from './RichText'

interface TruncatedRichTextProps {
  content: SerializedRichText
  noOfLines: number
}

export default function TruncatedRichText({
  content,
  noOfLines,
}: TruncatedRichTextProps): JSX.Element {
  return (
    <Box
      overflow="hidden"
      className="fade"
      css={css`
      display: -webkit-box;
      -webkit-line-clamp: ${noOfLines};
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      word-break: break-word;
      max-height: ${noOfLines * LINE_HEIGHTS.default}em;
    `}
    >
      <RichText content={content} />
    </Box>
  )
}
